/**
 * Initialize a `$storage` magic value for Alpine.
 *
 * `$storage` exposes functions to save and restore data
 * from and to `localStorage` and `sessionStorage`.
 *
 * Usage:
 *
 * - `$storage.restoreData($data, "key")`
 *
 *   Restore the data stored in `localStorage` under the key
 *   `"key"` to the `$data` object.
 *
 * - `$storage.saveData($data, "key")`
 *
 *   Save the `$data` object to `localStorage` under the key `"key"`.
 *
 * A similar API is available for `sessionStorage`, under the key `"session"`.
 *
 * - `$storage.session.restoreData($data, "key")`
 * - `$storage.session.saveData($data, "key")`
 *
 * @param {import("alpinejs").Alpine} Alpine - The Alpine instance
 */
function init(Alpine) {
  Alpine.magic("storage", () => ({
    restoreData: restoreDataFromStorage(localStorage),
    saveData: saveDataToStorage(localStorage),
    session: {
      restoreData: restoreDataFromStorage(sessionStorage),
      saveData: saveDataToStorage(sessionStorage),
    },
  }));
}

function restoreDataFromStorage(storage) {
  return (data, key) => {
    const raw = storage.getItem(key);
    if (raw === null) return;

    const stored = JSON.parse(raw);
    Object.assign(data, stored);
  };
}

function saveDataToStorage(storage) {
  return (data, key) => {
    storage.setItem(key, JSON.stringify(data));
  };
}

export default init;
